import { Navigate, useLocation } from 'react-router';
import { useAuth } from '@/hooks/useAuth';

/**
 * AuthGuard — wraps protected routes.
 * If user is NOT authenticated, redirects to /login.
 * After successful login, user is redirected back to the originally requested page.
 */
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  console.log("[AuthGuard] render — path:", location.pathname, "isAuthenticated:", isAuthenticated, "isLoading:", isLoading, "user:", user?.username ?? "null");

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen" style={{ background: 'var(--bg-canvas)' }}>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 border-2 border-rb-brand border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-slate-400">Authenticating...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Save the current path so we can redirect back after login
    const redirectPath = location.pathname + location.search;
    if (redirectPath !== '/login') {
      try { sessionStorage.setItem('rb_redirect_after_login', redirectPath); } catch { /* ignore */ }
    }
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
